module.exports = __webpack_public_path__ + "img/tiptaplogo_white.d50e8e45.png";